export default "__VITE_ASSET__df33b2fd__"